var map = {
	"./defipulse.png": 426,
	"./discord.svg": 427,
	"./discord_white.svg": 262,
	"./gitbook.svg": 428,
	"./github.svg": 429,
	"./medium.svg": 430,
	"./telegram.svg": 431,
	"./twitter.svg": 432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 905;